import styled from 'styled-components'
import { THEME } from '../../constant'

export const StepFinalWrapper = styled.div`
  text-align: center;
  padding-top: 16px;
`
export const StepFinalText = styled.div`
  font-size: 18px;
  font-weight: 500;
  padding-bottom: 20px;
  text-align: ${props => props.textAlign ? props.textAlign : 'center'};
  @media only screen and (max-width: 768px) {
    font-size: 16px;
  }
`
export const StepFinalVar = styled.span`
  color: ${THEME.PRIMARY_COLOR};
  padding: 0 4px;
`